import { PropsWithChildren, FC } from 'react'

import Link from '~/core/Link'
import getColor from '~/lib/getColor'

interface DownloadRevisionLinkType {
    downloadUrl?: string | null
    placement?: string | null
    disabled?: boolean
}

const DownloadRevisionLink: FC<PropsWithChildren<DownloadRevisionLinkType>> = ({
    placement,
    downloadUrl,
    children,
    disabled = false,
}) => {
    return (
        <Link
            target="_blank"
            placement={placement}
            name="download-revision"
            data-test-target="additional-actions-cell-download"
            href={downloadUrl}
            style={{ color: getColor('blackAlpha65') }}
            disabled={disabled}
        >
            {children || 'Download'}
        </Link>
    )
}

export default DownloadRevisionLink
